import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const deltaColor = {
  up: "#0f6e56",
  down: "#d85a30",
  warn: "#b5790f",
};

const KpiCard = ({ label, value, delta, direction, accent }) => (
  <Paper
    variant="outlined"
    sx={{
      position: "relative",
      overflow: "hidden",
      borderRadius: "14px",
      p: "18px 20px",
      height: "100%",
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: "3px",
        background: accent,
      },
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 500 }}>
        {label}
      </Typography>
    </Stack>
    <Typography sx={{ fontWeight: 700, fontSize: 27, mt: 1 }}>{value}</Typography>
    <Stack
      direction="row"
      alignItems="center"
      sx={{ mt: 0.75, color: deltaColor[direction], fontSize: 11.5, fontWeight: 600 }}
    >
      {direction === "up" && <ArrowDropUpIcon fontSize="small" />}
      {direction === "down" && <ArrowDropDownIcon fontSize="small" />}
      <Box component="span">{delta}</Box>
    </Stack>
  </Paper>
);

export default KpiCard;
